
      var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTvIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22.124,
  height: 18.988,
  viewBox: "0 0 22.124 18.988"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".TvIcon_ad03a932c8892397__cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-width:2px}"))), /*#__PURE__*/React.createElement("g", {
  id: "TvIcon_ad03a932c8892397__Group_7821",
  "data-name": "Group 7821",
  transform: "translate(-278 -208)"
}, /*#__PURE__*/React.createElement("g", {
  id: "TvIcon_ad03a932c8892397__Rectangle_4384",
  "data-name": "Rectangle 4384",
  className: "TvIcon_ad03a932c8892397__cls-1",
  transform: "translate(278 208)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22.124,
  height: 15.013,
  rx: 2,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 20.124,
  height: 13.013,
  rx: 1,
  style: {
    fill: "none"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "TvIcon_ad03a932c8892397__Line_68",
  "data-name": "Line 68",
  className: "TvIcon_ad03a932c8892397__cls-1",
  transform: "translate(289.062 221.828)",
  d: "M0 0v3.922"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "TvIcon_ad03a932c8892397__Line_69",
  "data-name": "Line 69",
  className: "TvIcon_ad03a932c8892397__cls-1",
  transform: "translate(282.736 225.988)",
  d: "M12.652 0H0"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22.124\" height=\"18.988\" viewBox=\"0 0 22.124 18.988\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-width:2px}\r\n        </style>\r\n    </defs>\r\n    <g id=\"Group_7821\" data-name=\"Group 7821\" transform=\"translate(-278 -208)\">\r\n        <g id=\"Rectangle_4384\" data-name=\"Rectangle 4384\" class=\"cls-1\" transform=\"translate(278 208)\">\r\n            <rect width=\"22.124\" height=\"15.013\" rx=\"2\" style=\"stroke:none\"/>\r\n            <rect x=\"1\" y=\"1\" width=\"20.124\" height=\"13.013\" rx=\"1\" style=\"fill:none\"/>\r\n        </g>\r\n        <path id=\"Line_68\" data-name=\"Line 68\" class=\"cls-1\" transform=\"translate(289.062 221.828)\" d=\"M0 0v3.922\"/>\r\n        <path id=\"Line_69\" data-name=\"Line 69\" class=\"cls-1\" transform=\"translate(282.736 225.988)\" d=\"M12.652 0H0\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/TvIcon.ad03a932c88923973888bce95923b306.svg"),
        {
          React: SvgTvIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      